


























































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class ExpensesReportTable extends Vue {
  @Prop({ required: true }) report!: any;

  formatter = Intl.NumberFormat("ja-JP", {
    style: "currency",
    currency: "JPY"
  });

  percentFormatter = Intl.NumberFormat("ja-JP", {
    style: "percent"
  });

  get backgroundColor(): string[] {
    const colors = this.report.report.colors;
    return colors;
  }
}
